import { AccountIcon, Typography } from "@kyan/ui";

import {
  WelcomeModalIcon,
  type WelcomeModalIconProps,
} from "../WelcomeModalIcon/WelcomeModalIcon";

export interface MarginAccountSlideProps {
  width: number;
  height: number;
  icons: WelcomeModalIconProps[];
}

export const MarginAccountSlide: React.FC<MarginAccountSlideProps> = ({
  width,
  height,
  icons,
}) => {
  return (
    <div className="flex h-54 flex-col items-center gap-3">
      <div className="flex flex-col items-center gap-1 pt-4">
        <AccountIcon variant="pink" />
        <Typography primary>Kyan Account</Typography>
      </div>

      <svg
        fill="none"
        width={width}
        height={height}
        className="text-divider"
        viewBox={`0 0 ${width} ${height}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x2={0}
          y1="0"
          y2={height}
          x1={width / 2}
          strokeWidth="1"
          stroke="currentColor"
        />
        <line
          y1={0}
          y2={height}
          x1={width / 2}
          x2={width / 2}
          strokeWidth="1"
          stroke="currentColor"
        />
        <line
          y1={0}
          x2={width}
          y2={height}
          x1={width / 2}
          strokeWidth="1"
          stroke="currentColor"
        />
      </svg>

      <div className="flex w-full justify-between px-10">
        {icons.map((icon) => (
          <WelcomeModalIcon key={icon.name} {...icon} />
        ))}
      </div>
    </div>
  );
};
